import { DrawdownManagementView } from '../components/drawdowns/DrawdownManagementView';
import { useFunds } from '@/hooks/react-query/useFunds';
import { DataLoader } from '@/components/ui/DataLoader';
import { FundSummary } from '@/types/fund';

export default function CapitalCallsPage() {
  const { data: funds = [], isLoading, error } = useFunds();

  return (
    <DataLoader
      data={funds}
      isLoading={isLoading}
      error={error}
      loadingComponent={
        <div className="p-6">
          <div className="flex justify-center items-center py-12">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            <span className="ml-3 text-gray-600">Loading funds...</span>
          </div>
        </div>
      }
    >
      {(funds: FundSummary[]) => (
        <div className="p-6">
          <DrawdownManagementView funds={funds} />
        </div>
      )}
    </DataLoader>
  );
}
